import * as React from 'react'
import createSvgIcon from '../createSvgIcon'

export default createSvgIcon(
  <>
    <path d='M5 6.99H8V14H10V6.99H13L9 3L5 6.99ZM14 10V17.01H11L15 21L19 17.01H16V10H14Z' />
  </>,
  'Sort'
)
